export const calculateStandardDeviation = (numbers: number[]): number => {
  if (numbers.length <= 1) {
    return 0 // Standard deviation for a single value is 0.
  }

  const mean =
    numbers.reduce((total, number) => total + number, 0) / numbers.length

  const squaredDifferences = numbers.map((number) => Math.pow(number - mean, 2))

  const variance =
    squaredDifferences.reduce((total, squaredDiff) => total + squaredDiff, 0) /
    (numbers.length - 1)

  return Math.sqrt(variance)
}

export const findLowThresholdByStandardDeviation = (
  numbers: number[],
  numDeviations: number,
): number | undefined => {
  if (numbers.length === 0) {
    return undefined
  }

  const mean =
    numbers.reduce((total, number) => total + number, 0) / numbers.length
  const standardDeviation = calculateStandardDeviation(numbers)

  const threshold = mean - numDeviations * standardDeviation

  return threshold
}
